module.exports = __webpack_public_path__ + "static/media/rewards-img.946fd11b.png";